"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function PresetOption(_ref) {
  var className = _ref.className,
      isSelected = _ref.isSelected,
      label = _ref.label,
      onClick = _ref.onClick;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(className, 'py-2 px-3 text-sm tracking-wide rounded-sm cursor-pointer', {
      'hover:bg-gray-light': !isSelected,
      'bg-primary text-white': isSelected
    }),
    onClick: onClick
  }, label);
}

var _default = PresetOption;
exports.default = _default;